module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":"Login"},"button":"Login","forgot":"I forgot my password","title":"Login","email":"Email","password":"Password","signup":"Signup"}}')
  delete Component.options._Ctor
}
